export default "__VITE_ASSET__krJqd3h3__"